export const setSessionTimeout = (setSessionTimerCount, setMode) => {
    setSessionTimerCount(600);
    setTimeout(() => {
        sessionStorage.removeItem("filesToken");
        setMode('form');
    }, 600000);
}
